import { render, staticRenderFns } from "./BridgeLootOutModal.vue?vue&type=template&id=063d9ffe&scoped=true&"
import script from "./BridgeLootOutModal.vue?vue&type=script&lang=js&"
export * from "./BridgeLootOutModal.vue?vue&type=script&lang=js&"
import style0 from "./BridgeLootOutModal.vue?vue&type=style&index=0&id=063d9ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d9ffe",
  null
  
)

export default component.exports